import React, { useState, useEffect, useCallback } from "react";
import { Avatar } from "antd";
import axiosInstance from "@/axios/axiosInstance";
import { useUser } from "@/assets/UserContext";
import { Menu } from "antd";
import MeaPage from "./mespage";
import Account from "./account";
import "./index.scss";

function maskPhoneNumber(phoneNumber) {
  // 假设phoneNumber是一个字符串类型的电话号码
  if (phoneNumber && phoneNumber.length !== 11) {
    return "无效的电话号码";
  }

  // 提取前3位数字
  const prefix = phoneNumber && phoneNumber.slice(0, 3);
  // 提取后4位数字
  const suffix = phoneNumber && phoneNumber.slice(7);
  // 用星号替换中间4位
  const masked = prefix + "****" + suffix;

  return masked;
}

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const items = [
  getItem("个人资料", "1"),
  getItem("账号管理", "12"),
  getItem("实名验证", "13"),
];

const UserInfo = () => {
  const { loginUser } = useUser();

  const [userData, setUserData] = useState({}); // 初始选中的菜单项
  const [selectedKey, setSelectedKey] = useState("1"); // 初始选中的菜单项

  const fetchUserInfo = useCallback(async () => {
    try {
      const response = await axiosInstance.get(`/account/detail`);
      setUserData(response.data.data);
      loginUser(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  }, [loginUser]);

  useEffect(() => {
    fetchUserInfo();
  }, [fetchUserInfo]);

  const handleMenuClick = (e) => {
    setSelectedKey(e.key); // 更新选中的菜单项
  };

  const renderContent = () => {
    switch (selectedKey) {
      case "1":
        return <MeaPage userData={userData} fetchUserInfo={fetchUserInfo} />;
      case "12":
        return <Account userData={userData} fetchUserInfo={fetchUserInfo} />;
      case "3":
        return 3;
      case "17":
        return 4;
      default:
        return <div>默认内容</div>;
    }
  };

  return (
    <div className="user_content">
      <div className="content">
        <div className="content_bot">
          <div className="content_bot_lef">
            <div className="bot_lef_top">
              <Avatar
                shape="square"
                size={80}
                src={`/file/${userData.profilePictureUrl}`}
                className="photo"
              />
              <div className="name">
                <h4>{maskPhoneNumber(userData.phone)}</h4>
                <div>性别：{userData.sex === 2 ? "女" : "男"}</div>
                <div>工作年限：{userData.workYears}</div>
              </div>
            </div>
            <div className="dec">
              {userData.personalIntroduce || "这个人很忙，暂时未填写个人介绍"}
            </div>
            <Menu
              onClick={handleMenuClick}
              style={{
                width: 256,
              }}
              defaultSelectedKeys={["1"]}
              defaultOpenKeys={["sub1"]}
              mode="inline"
              items={items}
            />
          </div>
          <div className="content_bot_rig content_right_user">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
